var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.25C8.88071 6.25 10 5.13071 10 3.75C10 2.36929 8.88071 1.25 7.5 1.25C6.11929 1.25 5 2.36929 5 3.75C5 5.13071 6.11929 6.25 7.5 6.25Z",
    stroke: "#3E0292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.375L8.75 13.125",
    stroke: "#3E0292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.0215C8.35394 13.0888 7.93437 13.125 7.5 13.125C5.08376 13.125 3.125 12.0057 3.125 10.625C3.125 9.24431 5.08376 8.125 7.5 8.125C8.57094 8.125 9.552 8.34487 10.3125 8.70994",
    stroke: "#5E75B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 13.75C12.0057 13.75 13.125 12.6307 13.125 11.25C13.125 9.86929 12.0057 8.75 10.625 8.75C9.24429 8.75 8.125 9.86929 8.125 11.25C8.125 12.6307 9.24429 13.75 10.625 13.75Z",
    stroke: "#3E0292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlock);
export default __webpack_public_path__ + "static/media/userBlock.6c69fe7ad8a6001b722fa4706c380e28.svg";
export { ForwardRef as ReactComponent };